import React from "react";
import { twMerge } from "tailwind-merge";

export type InputSize = "sm" | "md";

export type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> & {
  size?: InputSize;
};

export const INPUT_BASE =
  "block w-full min-w-0 [@media(pointer:coarse)]:min-h-11 rounded-md border border-od-interactive-boundary bg-od-surface px-3 text-sm text-od-text transition-colors placeholder:text-od-muted hover:border-od-primary-text focus:border-od-primary-text focus:outline-none focus:ring-2 focus:ring-od-primary-text disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-od-danger aria-[invalid=true]:focus:ring-od-danger";

export const INPUT_SIZES: Record<InputSize, string> = {
  sm: "min-h-11 sm:h-8 sm:min-h-0",
  md: "min-h-11",
};

export const inputClassName = (size: InputSize = "md", extra?: string): string =>
  twMerge(INPUT_BASE, INPUT_SIZES[size], extra);

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ size = "md", className, type = "text", ...rest }, ref) => (
    <input
      ref={ref}
      type={type}
      data-size={size}
      className={inputClassName(size, className)}
      {...rest}
    />
  )
);

Input.displayName = "Input";
